import { render, staticRenderFns } from "./RoundsPage.vue?vue&type=template&id=5e81ce27"
import script from "./RoundsPage.vue?vue&type=script&lang=js"
export * from "./RoundsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports